import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { validateEmail } from "../../../validators/email.validator";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { KeyValuePipe, NgClass } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: 'email-control',
    templateUrl: '../text-control/text-control.component.html',
    styleUrls: [
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
        KeyValuePipe
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class EmailControl extends BaseInputControl implements OnInit {

    constructor() {
        super();
        this.inputType = 'email';
    }

    override ngOnInit(): void {
        this.addEmailValidation();
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }

    private addEmailValidation(): void {
        this.validators.push(validateEmail());
    }
}
